import React from 'react';
import {SistemaPrincipal, SistemaPrincipalFields} from "../../../../types/workflow/cache";
import {Avatar, Typography} from "@mui/material";
import {styled} from "@mui/material/styles";
import Badge from "@mui/material/Badge";
import CheckIcon from '@mui/icons-material/Check';
import {getInitials} from "../../../../@core/utils/get-initials";
import {EntityWithIdAndDescriptionFields} from "../../../../types";
import {TipoMensaje} from "../../types";

// ** Styled Components
const BadgeCheckIcon = styled(CheckIcon)(({theme}) => ({
    width: 8,
    height: 8,
    borderRadius: '50%',
    backgroundColor: theme.palette.success.main,
    boxShadow: `0 0 0 2px ${theme.palette.background.paper}`
}))

type AvatarSistemaPrincipalProps = {
    sistemaPrincipal: SistemaPrincipal,
    isSelected?: boolean,
}


export function AvatarSistemaPrincipal({sistemaPrincipal, isSelected}: AvatarSistemaPrincipalProps) {
    return (
        <Badge
            overlap='circular'

            badgeContent={isSelected && <BadgeCheckIcon/>}
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'right'
            }}
        >
            <Avatar src={sistemaPrincipal[SistemaPrincipalFields.SrcIcono]} sx={{

                // p: 0,
                // width: 32,
                // height: 32,

                //backgroundColor: isSelected ? 'primary.main' : 'grey.300',
                border: isSelected ? '2px solid' : '0px solid',
                borderColor: isSelected ? 'primary.main' : 'grey.300',

                // opacity: isSelected ? 1 : 0.5,

                filter: isSelected ? 'none' : 'grayscale(100%)',

            }}/>
        </Badge>
    );
}

type AvatarSistemaProps = {
    sistema: TipoMensaje,
    isSelected?: boolean,
}

export function AvatarSistema({sistema, isSelected}: AvatarSistemaProps) {
    return (
        <Badge
            overlap='circular'

            badgeContent={isSelected && <BadgeCheckIcon/>}
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'right'
            }}
        >
            <Avatar sx={{
                width: 32,
                height: 32,
                opacity: isSelected ? 1 : 0.5,
                filter: isSelected ? 'none' : 'grayscale(100%)',
            }}>
                <Typography fontSize={'medium'}>
                    {getInitials(sistema[EntityWithIdAndDescriptionFields.Description])}
                </Typography>
            </Avatar>
        </Badge>
    );
}